import styled from "styled-components";
import { ThemeProvider } from "styled-components";
import eror from "../img/error.jpg";
//Style tutaj
const Kratka = styled.div`
  display: flex;
  width: 100%;
  box-shadow: #000 0 0 10px;
  background-image: url(${(props) => props.img || eror});
  /* max-width: 270px; */
  min-width: 200px;
  /* height: 100%; */
  max-height: 170px;
  transition: 0.3s;
  aspect-ratio: 16/9;

  background-size: 100% 100%;
  cursor: pointer;
  &:hover {
    transform: scale(1.15);
  }
`;
const Thefuck = styled.div`
  width: 100%;
  height: 100%;
  user-select: none;
  transition: 0.3s;

  background-color: none;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
  &:hover > p {
    opacity: 1 !important;
  }
  & > p {
    transition: 300ms;
    text-align: center;
    color: #f8ffe8;
    font-size: 1.25rem;
    margin: 100% 80%;
    border: 0.2rem solid ${(props) => props.theme.main};
    border: #f8ffe8 0.2rem solid;
    padding: 0.5rem 0.7rem;
    border-radius: 2vh;
    opacity: 0;
  }
`;
Thefuck.defaultProps = {
  theme: {
    main: "palevioletred",
  },
};
const theme = {
  main: "mediumseagreen",
};

function Tile(props) {
  return (
    <Kratka
      onClick={() => {
        props.funkcja(props.kontent);
      }}
      img={props.obraz}
    >
      <Thefuck>
        <p>{props.nazwa}</p>
      </Thefuck>
    </Kratka>
  );
}

export default Tile;
